import { createContext, useState } from "react";

const CurrentOrderContext = createContext({
  currentOrder: undefined,
  setCurrentOrder: (currentOrder: any) => {},
});

const CurrentOrderContextProvider = ({ children }) => {
  const [currentOrder, setCurrentOrder] = useState(undefined);

  return (
    <CurrentOrderContext.Provider value={{ currentOrder, setCurrentOrder }}>
      {children}
    </CurrentOrderContext.Provider>
  );
};

export { CurrentOrderContext, CurrentOrderContextProvider };
